import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  Paper,
} from "@mui/material";

const ComingSoon = ({pagesName}) => {
  const targetDate = new Date("2025-11-31T00:00:00");
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    mins: 0,
    secs: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          mins: Math.floor((difference / 1000 / 60) % 60),
          secs: Math.floor((difference / 1000) % 60),
        });
      } else {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "50vh",
        // background: "linear-gradient(135deg, #0D47A1, #1A237E)",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        mt:5
      }}
    >
      <Container>
        <Paper
          elevation={8}
          sx={{
            backgroundColor: "rgba(255,255,255,0.08)",
            backdropFilter: "blur(10px)",
            borderRadius: 4,
            p: 4,
          }}
        >
          {/* Başlık */}
          <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
            🚀 Yakında Hizmetinizde!
          </Typography>

          <Typography variant="body1" sx={{ color: "gray", mb: 4 }}>
            {`${pagesName} modülü üzerinde çalışıyoruz. Çok yakında sizlerle olacağız.`}
          </Typography>

          {/* Geri Sayım */}
          <Grid container spacing={2} justifyContent="center" sx={{ mb: 4 }}>
            {[
              { label: "Gün", value: timeLeft.days },
              { label: "Saat", value: timeLeft.hours },
              { label: "Dakika", value: timeLeft.mins },
              { label: "Saniye", value: timeLeft.secs },
            ].map((item, index) => (
              <Grid item key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(61, 74, 247, 0.12)",
                    color: "gray",
                  }}
                >
                  <Typography variant="h5" fontWeight="bold">
                    {item.value}
                  </Typography>
                  <Typography variant="caption" color="gray">
                    {item.label}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* E-posta bildirimi */}
          {/* <Typography variant="body2" color="#b0bec5" sx={{ mb: 1 }}>
            Haberdar olmak ister misiniz?
          </Typography> */}

          {/* <Box
            component="form"
            onSubmit={(e) => e.preventDefault()}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: "center",
            }}
          >
            <TextField
              type="email"
              placeholder="E-posta adresiniz"
              variant="outlined"
              size="small"
              sx={{
                bgcolor: "white",
                borderRadius: 1,
                input: { color: "black" },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: "#1976d2",
                fontWeight: "bold",
                "&:hover": { bgcolor: "#1565c0" },
              }}
            >
              Bildir
            </Button>
          </Box> */}

          {/* <Typography
            variant="caption"
            display="block"
            sx={{ mt: 6, color: "#90a4ae" }}
          >
            © {new Date().getFullYear()} Tüm Hakları Saklıdır.
          </Typography> */}
        </Paper>
      </Container>
    </Box>
  );
};

export default ComingSoon;
